import React, { useRef, useState } from "react";
import clsx from "clsx";
import styles from "./STFileUpload.module.css";
import { Icons } from "@/const/icons";

export const STFileUpload = ({
  label,
  name,
  onChange,
  error,
  required,
  className,
  buttonClass,
  accept,
}) => {
  const fileInputRef = useRef(null);
  const [fileName, setFileName] = useState("");

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFileName(file.name);
      if (onChange) onChange(file);
    }
  };

  const handleButtonClick = () => {
    fileInputRef.current?.click();
  };

  return (
    <div className={clsx(styles.wrapper, className)}>
      {label && (
        <label className={styles.label}>
          {label}
        </label>
      )}
      <div className={styles.uploadWrapper}>
        <button
          type="button"
          className={clsx(styles.uploadButton, buttonClass)}
          onClick={handleButtonClick}
        >
          <span className={styles.icon}>{Icons.paperclipIcon}</span>
          <span className={styles.buttonText}>
            {fileName || "Attach file here"}
          </span>
        </button>
        <input
          type="file"
          ref={fileInputRef}
          name={name}
          onChange={handleFileChange}
          className={styles.hiddenInput}
          accept={accept}
        />
      </div>
      {error && <p className={clsx(styles.errorText, "text-danger")}>{error}</p>}
    </div>
  );
};
